<div class="header-content__header">
  @if (config?.label) {
    <h5 [innerHTML]="config?.label"></h5>
  }
</div>

<div class="header-content__content">
  <ng-content></ng-content>
</div>
